import { useGetCompanyNameQuery } from '@contract-root/admin-react/src/generated/graphql';
import { yupResolver } from '@hookform/resolvers';
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Autocomplete } from '@material-ui/lab';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import {
  GetCompanyLetterTemplateDocument,
  useCreateCompanyLetterTemplateMutation,
  useDeleteCompanyLetterTemplateMutation,
  useGetCompanyLetterTemplateQuery,
  useGetLetterTemplateQuery,
  useGetStandardLetterQuery,
  useUpdateCompanyLetterTemplateMutation,
} from 'generated/graphql';
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation';
import { useMenuOption } from 'helpers/Hooks/useMenuOption';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import { CommonYupValidation } from 'helpers/YupSchema/yup';
import { Controller, useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router';
import * as yup from 'yup';
import React, { useContext, useState } from 'react';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';

export interface CompanyLetterTemplateProps {
  name: string;
  isDefault: boolean;
  letterTemplateID: string;
}

export const CompanyLetterTemplateListing = (props: any) => {
  const { pageMode, standardLetterID, companyID }: any = useParams();
  let history = useHistory();
  const {
    anchorEl,
    menu,
    handleClick,
    handleClose,
    resetMenu,
  } = useMenuOption();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const isHomeDefault = localStorage.getItem('isDefault');
  const [deleteLT, setDeleteLT] = useState(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openExitConf, setOpenExitConf] = useState<boolean>(false);
  const [formMode, setFormMode] = useState('');
  const [headerTitle, setHeaderTitle] = useState<string>('');
  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);

  const CompanyLetterTemplateFormSchema = yup.object().shape({
    name: CommonYupValidation.requireField(SystemMsgs.name()),
    letterTemplateID: CommonYupValidation.requireField(
      'Letter Template is required',
    ),
  });

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any,
  );

  const {
    register,
    handleSubmit,
    errors,
    control,
    setValue,
    watch,
    reset,
    formState: { isDirty },
  } = useForm<CompanyLetterTemplateProps>({
    defaultValues: {},
    shouldUnregister: false, // unmount input state will be remained
    resolver: yupResolver(CompanyLetterTemplateFormSchema),
  });

  const {
    loading: getCompanyloading,
    data: { getCompany: curCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    fetchPolicy: 'network-only',
    variables: { companyID },
    onCompleted: () => {
      let headerTitle: string = '';
      switch (pageMode) {
        case 'client-account':
          headerTitle = smallTitle.CLIENT_ACCOUNTS;
          break;
        case 'subcontractor':
          headerTitle = smallTitle.SUBCON_ACCOUNTS;
          break;
        case 'subcontract':
          headerTitle = smallTitle.SUB_CONTRACT_MANAGEMENT;
          break;
        case 'supplier':
          headerTitle = smallTitle.SUPPLIER_ACCOUNTS;
          break;
        case 'client-contract':
          headerTitle = smallTitle.PROJECT_PURCHASES;
          break;
        case 'project-costing':
          headerTitle = smallTitle.PROJECT_COSTING;
          break;
        default:
          headerTitle = smallTitle.PRODUCT;
          break;
      }
      setHeaderTitle(headerTitle);
    },
  });

  const {
    loading: standardLetterloading,
    data: { getStandardLetter } = { getStandardLetter: [] },
  } = useGetStandardLetterQuery({
    fetchPolicy: 'network-only',
    variables: { standardLetterID },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const {
    loading: getLetterTemplateloading,
    data: { getLetterTemplate } = {
      getLetterTemplate: [],
    },
  } = useGetLetterTemplateQuery({
    fetchPolicy: 'network-only',
    variables: { standardLetterID },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const {
    loading: getCompanyLetterTemplateloading,
    data: { getCompanyLetterTemplate } = {
      getCompanyLetterTemplate: [],
    },
  } = useGetCompanyLetterTemplateQuery({
    fetchPolicy: 'network-only',
    variables: { standardLetterID, companyID },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    createCompanyLetterTemplate,
    { loading: createCompanyLetterTemplateLoading },
  ] = useCreateCompanyLetterTemplateMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
    onCompleted: ({ createCompanyLetterTemplate }) => {
      setOpenSnackBar(true);
      setSnackBarMsg(SystemMsgs.createNewRecord());
      if (createCompanyLetterTemplate) {
        setSnackBarMsg('Created Successfully!');
        setOpen(false);
      } else {
        setSnackBarMsg('Create Failed!');
      }
    },
  });

  const [
    //updateCompanyLetterTemplate to updateCompanyLetterTemplate
    updateCompanyLetterTemplate,
    { loading: updateCompanyLetterTemplateLoading },
  ] = useUpdateCompanyLetterTemplateMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
    onCompleted: ({ updateCompanyLetterTemplate }) => {
      if (updateCompanyLetterTemplate) {
        setOpenSnackBar(true);
        setSnackBarMsg(SystemMsgs.updateRecord());
        setOpen(false);
      } else {
        setSnackBarMsg('Update Failed!');
      }
    },
  });

  const [
    //deleteCompanyLetterTemplate to deleteCompanyLetterTemplate
    deleteCompanyLetterTemplate,
    { loading: deleteCompanyLetterTemplateLoading },
  ] = useDeleteCompanyLetterTemplateMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
    onCompleted: ({ deleteCompanyLetterTemplate }) => {
      setOpenSnackBar(true);
      setSnackBarMsg(SystemMsgs.deleteRecord());
      setDeleteLT(false);
      if (deleteCompanyLetterTemplate) {
        setSnackBarMsg('Deleted Successfully!');
        setDeleteLT(false);
      } else {
        setSnackBarMsg('Delete Failed!');
      }
    },
  });

  const onSubmit = (data, menu) => {
    if (formMode === 'edit') {
      updateCompanyLetterTemplate({
        variables: {
          input: {
            ID: menu?.obj?.ID,
            name: data?.name,
            standardLetterID,
            companyID,
            isDefault: data?.isDefault,
            letterTemplateID: data?.letterTemplateID,
          },
        },
        refetchQueries: [
          {
            query: GetCompanyLetterTemplateDocument,
            variables: { standardLetterID, companyID },
          },
        ],
      });
    } else if (formMode === 'add') {
      createCompanyLetterTemplate({
        variables: {
          input: {
            name: data?.name,
            standardLetterID,
            companyID,
            isDefault: data?.isDefault,
            letterTemplateID: data?.letterTemplateID,
          },
        },
        refetchQueries: [
          {
            query: GetCompanyLetterTemplateDocument,
            variables: { standardLetterID, companyID },
          },
        ],
      });
    }
  };

  const handleDelete = data => {
    deleteCompanyLetterTemplate({
      variables: {
        input: { ID: data?.ID },
      },
      refetchQueries: [
        {
          query: GetCompanyLetterTemplateDocument,
          variables: { standardLetterID, companyID },
        },
      ],
    });
    setDeleteLT(false);
  };

  const checkSameName = () => {
    const getLT = !menu?.obj
      ? getCompanyLetterTemplate
      : getCompanyLetterTemplate?.filter(x => x?.ID !== menu?.obj?.ID);

    const sameName = getLT?.filter(
      el => el?.name.toLocaleLowerCase() === watch('name')?.toLocaleLowerCase(),
    );

    if (sameName?.length > 0) {
      return true;
    } else return false;
  };

  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: menu?.obj,
      formMode: formMode,
    });

  return (
    <>
      {getCompanyloading && <Loading />}
      {standardLetterloading && <Loading />}
      {getLetterTemplateloading && <Loading />}
      {getCompanyLetterTemplateloading && <Loading />}
      {createCompanyLetterTemplateLoading && <Loading />}
      {updateCompanyLetterTemplateLoading && <Loading />}
      {deleteCompanyLetterTemplateLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname: `/company-setup/submenu/${companyID}/standard-letter`,
          });
        }}
        smTitle={isHomeDefault === 'true' ? 'AccountX' : headerTitle}
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'System Admin' },
          { name: 'Document Template' },
          { name: 'Company Letter Template', current: true },
        ]}
      />
      <DynamicSubHeader
        title={curCompany[0]?.Name}
        infoLine={getStandardLetter[0]?.name}
      />
      <ContentWrapper multiDynamicInfo>
        {getCompanyLetterTemplate?.length === 0 ? (
          <EmptyList
            title="No Company Letter Template"
            subtitle="Please create new Company Letter Template"
          />
        ) : (
          <List className="core-list">
            {getCompanyLetterTemplate?.map((v, index) => (
              <ListItem>
                <ListItemText
                  primary={
                    <div className="xsTitle">
                      <span>{v?.name}</span>
                      {v?.isDefault === true ? (
                        <span>
                          <CheckCircleIcon
                            style={{ color: 'limegreen', fontSize: 'medium' }}
                          />
                        </span>
                      ) : null}
                    </div>
                  }
                  secondary={
                    <span className="desc">{v?.isReportDesignEditor}</span>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    aria-controls="menu-list"
                    aria-haspopup="true"
                    onClick={e => handleClick(e, v?.ID, index, v)}
                  >
                    <MoreVert />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </ContentWrapper>
      <CommonDialog
        fullWidth={true}
        open={open}
        onClose={() => {
          if (hasChanges() === true) {
            setOpenExitConf(true);
          } else {
            setOpen(false);
            reset();
            resetMenu();
          }
        }}
        sections={{
          header: {
            title: 'Company Letter Template',
            rightText: formMode === 'edit' ? 'Edit' : 'New',
          },
          body: () => (
            <>
              <div className="content-container">
                <Controller
                  as={TextField}
                  id="standard-basic"
                  name="name"
                  label={'Name'}
                  required
                  control={control}
                  fullWidth
                  helperText={
                    checkSameName() === true
                      ? 'Name already exsist.'
                      : errors?.name
                      ? errors?.name.message
                      : null
                  }
                  error={
                    checkSameName() === true || errors?.name ? true : false
                  }
                  ref={register}
                />

                <Controller
                  render={({ value, onChange }) => {
                    const defVal = getLetterTemplate?.filter(
                      x => x?.ID === menu?.obj?.letterTemplateID,
                    )[0];
                    return (
                      <Autocomplete
                        options={
                          getLetterTemplate?.sort((a, b) => {
                            return a?.name?.localeCompare(b?.name);
                          }) || []
                        }
                        getOptionLabel={option => `${option?.name}`}
                        fullWidth
                        onChange={(value, newValue: any) => {
                          setValue('letterTemplateID', newValue?.ID);
                          onChange(newValue?.ID);
                        }}
                        renderOption={(props, option) => {
                          return <span>{props?.name}</span>;
                        }}
                        defaultValue={defVal}
                        renderInput={(params: any) => {
                          return (
                            <div>
                              <TextField
                                {...params}
                                helperText={errors?.letterTemplateID?.message}
                                error={errors?.letterTemplateID ? true : false}
                                label="Letter Template"
                                style={{ width: '100%' }}
                                margin="dense"
                                required
                              />
                            </div>
                          );
                        }}
                      />
                    );
                  }}
                  label="Letter Template"
                  name="letterTemplateID"
                  autoComplete="off"
                  control={control}
                  multiline={true}
                  fullWidth
                  margin="dense"
                  ref={register}
                  helperText={errors?.letterTemplateID?.message}
                  error={errors?.letterTemplateID ? true : false}
                  defaultValue={menu?.obj?.letterTemplateID}
                  required
                />

                <FormControl component="fieldset">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={watch('isDefault')}
                        onChange={e => setValue('isDefault', e.target.checked)}
                        name="isDefault"
                        color="primary"
                        defaultValue={menu?.obj?.isDefault}
                      />
                    }
                    label="Default"
                  />
                </FormControl>
              </div>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    if (hasChanges() === true) {
                      setOpenExitConf(true);
                    } else {
                      setOpen(false);
                      reset();
                      resetMenu();
                    }
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => handleSubmit(data => onSubmit(data, menu))(),
                  variant: 'contained',
                  color: 'primary',
                  disabled: checkSameName(),
                },
              },
            ],
          },
        }}
      />
      <FloatButton
        onClick={() => {
          setValue('name', '');
          // setValue('JointBuyerSignRequired', false)
          // setValue('IsReportDesignEditor', false)
          setValue('isDefault', false);
          setValue('letterTemplateID', '');
          setOpen(true);
          setFormMode('add');
          resetMenu();
        }}
      />
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          // disabled={handlePermDisabled({
          //   companyID: companyID,
          //   permEnum: AcctPermission.AccPayableBatchPaymentUpdate,
          // })}
          onClick={() => {
            history.push({
              pathname: `/company-setup/submenu/${companyID}/standard-letter/${standardLetterID}/letter-template/${menu?.obj?.ID}/design`,
              state: menu?.obj,
            });
          }}
        >
          Design
        </MenuItem>
        <MenuItem
          // disabled={handlePermDisabled({
          //   companyID: companyID,
          //   permEnum: AcctPermission.AccPayableBatchPaymentDelete,
          // })}
          onClick={() => {
            setValue('name', menu?.obj?.name);
            // setValue(
            //   'JointBuyerSignRequired',
            //   menu?.obj?.JointBuyerSignRequired
            // )
            // setValue('IsReportDesignEditor', menu?.obj?.IsReportDesignEditor)
            setValue('isDefault', menu?.obj?.isDefault);
            setValue('letterTemplateID', menu?.obj?.letterTemplateID);
            setOpen(true);
            setFormMode('edit');
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          // disabled={handlePermDisabled({
          //   companyID: companyID,
          //   permEnum: AcctPermission.AccPayableBatchPaymentDelete,
          // })}
          onClick={() => setDeleteLT(true)}
        >
          Delete
        </MenuItem>
      </Menu>
      <CommonDialog
        fullWidth
        open={deleteLT}
        onClose={() => setDeleteLT(false)}
        sections={{
          header: {
            title: 'Company Letter Template',
            rightText: `Delete`,
          },
          body: () => (
            <div className="content-wrap full">
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                  fontWeight: 500,
                }}
              >
                {`Are you sure you want to delete ${menu?.obj?.name}?`}
              </span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setDeleteLT(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    handleDelete(menu?.obj);
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          setOpen(false);
          setOpenExitConf(false);
          reset();
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  );
};
